import { render, staticRenderFns } from "./Medal.vue?vue&type=template&id=6b11fc20"
import script from "./Medal.vue?vue&type=script&lang=js"
export * from "./Medal.vue?vue&type=script&lang=js"
import style0 from "./Medal.vue?vue&type=style&index=0&id=6b11fc20&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports